import { render, staticRenderFns } from "./ListingRoomTypes.vue?vue&type=template&id=a0fa71fc"
import script from "./ListingRoomTypes.vue?vue&type=script&lang=ts"
export * from "./ListingRoomTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports